import React, { useState, useEffect, useRef, Fragment } from "react"
import { toast } from "react-toastify"
import { FaSms, FaWhatsapp } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { getWhatsappLinkPayMessage, haveAuth } from "utils"
import { IconButton } from "components"
import { sendPaymentLinkSms } from "services"
import classes from "./OrderSendPaymentLink.module.scss"

const OrderSendPaymentLink = props => {
  const { order, paymentDetail } = props

  const [t, i18n] = useTranslation()

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handleSendSms = async () => {
    setLoading(true)

    try {
      await sendPaymentLinkSms(order._id)

      toast.success(t("SMS_ارسال_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("SMS_ارسال_نشد"))
    }

    if (unmount.current) return

    setLoading(false)
  }

  const handleShareLink = () => {
    const message =
      getWhatsappLinkPayMessage(order, paymentDetail._id)

    const url =
      `https://api.whatsapp.com/send?phone=${order.customerMobilePhone}&text=${encodeURIComponent(message)}`

    window.open(url, "_blank")
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      {
        haveAuth(["smsPaymentLink"]) &&
        <div
          className={classes["container"]}
          onClick={handleSendSms}
        >
          <IconButton
            size={18}
            icon={FaSms}
            loading={loading}
            loadingColor="black"
          />

          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("ارسال_SMS_لینک_پرداخت")}
          </span>
        </div>
      }

      <div
        className={classes["container"]}
        onClick={handleShareLink}
      >
        <IconButton
          size={18}
          icon={FaWhatsapp}
          disabled={loading}
          loadingColor="black"
        />

        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {t("ارسال_لینک_پرداخت_به_واتساپ")}
        </span>
      </div>
    </Fragment>
  )
}

export default OrderSendPaymentLink